import { type ReactNode } from "react";

import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";
import { type TooltipInfoVariant } from "ds/components/TooltipInfo";
import Typography from "ds/components/Typography";
import { getDocsUrl } from "utils/getDocsUrl";

type IntentProjectRunnerImageTooltipReturnType = {
  tooltipInfo: ReactNode;
  tooltipInfoVariant: TooltipInfoVariant;
};

const getIntentProjectRunnerImageTooltip = (): IntentProjectRunnerImageTooltipReturnType => ({
  tooltipInfo: (
    <>
      <TooltipModalTitle>Runner image</TooltipModalTitle>
      <TooltipModalBody align="start">
        <Typography tag="p" variant="p-body3">
          Every intent task runs in a separate Docker container. Setting a custom runner image
          provides a convenient way to prepare the exact runtime environment your intent project is
          designed to use. Leave empty to use the system default intent worker image.
        </Typography>
        <ReadMoreDocsLink
          docsUrl={getDocsUrl("/concepts/intelligence/intent/execution.html#per-project-runner-image")}
        />
      </TooltipModalBody>
    </>
  ),
  tooltipInfoVariant: "modal",
});

export default getIntentProjectRunnerImageTooltip;
